import { getHttpStatus } from "@/utils/httpErrors";

/**
 * A fixed, translated message for the Cities screens — never anything
 * derived from the response body — with the HTTP status appended when
 * known. Sim found a raw error body rendered on screen here (2026-09-28),
 * the same bug already fixed once for partner orders (`PartnerOrdersTable`,
 * 2026-09-27): every destination request now disables the generic
 * body-derived toast (`disableToast: true`, `admin-partners-service.ts`),
 * and every error surface in this feature goes through this helper instead.
 */
export function describeError(fallback: string, error?: unknown): string {
  const status = getHttpStatus(error);
  return status ? `${fallback} (${status})` : fallback;
}
